import Query from '../../../../components/Report';

export const query = ({ fromEnd, fromStart, toStart, toEnd }) =>
    new Query('search-algo-comparision-ctr', { fromEnd, fromStart, toStart, toEnd });
